<template>
  <div class="app-wrapp">
    <section class="bg-clay">
      <div class="article-wrapper">
        <div class="article-head article-head--a7">
          <h2 class="article-head__title article-head__title--a7">
            <div class="animated fadeInLeft" >
              {{ 'Тысячи россиян не могли устроить детям летний отдых. Как власти нашли способ им помочь?' | typograf }}
            </div>
            <div class="article-head__line article-head__line--71 img-w">
              <img src="@/assets/img/article7/line1.png" alt="">
            </div>
          </h2>
          <div class="article-head__img article-head__img--a7 img-w animated fadeInBottomRight">
            <img src="@/assets/img/article7/img1.png" alt="">
          </div>
        </div>
      </div>
    </section>

    <section class="article-text bg-clay">
      <div class="mobile-hidden article__img article__img11 img-w"  v-animate-onscroll="'animated fadeInRight'">
        <img src="@/assets/img/article7/img11.png" alt="">
      </div>
      <div class="mobile-hidden article__img article__img10 img-w" v-animate-onscroll="'animated fadeInRight'">
        <img src="@/assets/img/article7/img10.png" alt="">
      </div>
      <div class="mobile-hidden article__img article__img12 img-w" v-animate-onscroll="'animated fadeInLeft'">
        <img src="@/assets/img/article7/img12.png" alt="">
      </div>
      <div class="article-wrapper article-wrapper--mt3">
        <h3 class="article-text__h3" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Мы просто не смогли отправить сына на отдых»' | typograf }}
        </h3>
        <p class="article-text__subtitle" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Тем, кому за 40, не нужно объяснять, что такое детский лагерь: они наверняка знакомы с этим видом отдыха и его традициями. Каждое лето миллионы советских детей отправлялись жить особенной лагерной жизнью, учиться самостоятельности, а главное — набираться сил после утомительного учебного года.' | typograf }}
        </p>
      </div>
      <div class="article-text__shifted-box">
        <div class="article__img article__img2 img-w" v-animate-onscroll="'animated fadeInLeft'">
          <img src="@/assets/img/article7/img2.png" alt="">
        </div>
       <!-- <div class="article__line article__line2 img-w"  v-animate-onscroll="'animated fadeInDown'">
          <img src="@/assets/img/article7/line2.png" alt="">
        </div>-->
        <div class="article-wrapper article-wrapper--shifted">
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Советский Союз распался, страна Пионерия осталась в прошлом, но летние лагеря в России продолжали работать. Ставшие взрослыми пионеры отправляли туда на отдых уже своих детей, как будто передавая лагерную эстафету. Приобщить сына к культуре детских лагерей решила и Виктория Волкова из Ярославской области: в 2020 году она впервые собиралась отправить десятилетнего Егора на отдых.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Для этого Виктория выбрала тот самый лагерь, куда когда-то давно ездила почти каждый год. Ее сын с нетерпением ждал этого момента — в лагерь он должен был отправиться вместе с друзьями по футбольной секции. Но пандемия COVID-19 спутала Волковым все карты. Вначале, как и множеству других семей, Волковым пришлось перейти на самоизоляцию: в это время об отдыхе с другими детьми не могло быть и речи. Ограничения из-за COVID-19 сняли только к середине лета.' | typograf }}
          </p>
          <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[0]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'С одной стороны, желающих отправить детей в лагеря оказалось очень много, а принять они могли максимум половину желающих — так постановил Роспотребнадзор. С другой стороны, сыграли свою роль цены на детский отдых, которые оказались очень высокими, — они начинались от 14 тысяч рублей, а это почти половина  зарплаты Виктории — администратора в салоне красоты.' | typograf }}
          </p>
        </div>
      </div>
      <div class="article-wrapper article-wrapper--pb2">
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Во многих лагерях смены быстро укомплектовали из-за небольшого количества мест. Кроме того, путевки оказались дорогими, и наша семья просто не смогла отправить Егора на отдых», — вспоминает Виктория Волкова. В итоге маленький Егор все лето провел дома и на улицах своего города. Его мама уверена: в детском лагере ребенку было бы куда безопаснее, особенно во время пандемии.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'В похожей ситуации оказался житель подмосковного Долгопрудного Александр Патешман, который тоже не отправил свою 12-летнюю дочь в детский лагерь. «В моем детстве часто ездили в лагеря, а сейчас эта традиция практически забыта», — говорит многодетный отец.' | typograf }}
        </p>
        <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[5]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Без полноценного летнего отдыха в прошлом году оказались миллионы детей по всей России. По данным детского омбудсмена Анны Кузнецовой, вместо 5,6 миллиона детей (показатель 2019 года) в детских лагерях побывали всего 815 тысяч.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Вместе с тем летом 2020 года по сравнению с аналогичным периодом 2019-го в России в 70 раз увеличилось количество детей, получивших травмы и переломы. Количество детских смертей увеличилось почти вдвое и превысило 880. По словам детского омбудсмена, таких цифр в России не было никогда, и связано это с закрытием лагерей и отсутствием организованного отдыха.' | typograf }}
        </p>
        <Loading :class="{'is-loading-animated': isLoading}" />
        <div class="observer-move"></div>
        <Layers />
      </div>
    </section>

    <section id="element-container" class="article-text article-text--blue article-text--blue3 -no-blue">
      <div id="element-content">
        <div class="article-text__shifted-box">
          <div class="mobile-hidden article__img article__img3 img-w"  v-animate-onscroll="'animated fadeInRight'">
            <img src="@/assets/img/article7/img3.png" alt="">
          </div>
          <div class="mobile-hidden article__img article__img13 img-w"  v-animate-onscroll="'animated fadeInLeft'">
          <img src="@/assets/img/article7/img13.png" alt="">
        </div>
       <!-- <divclass="article__line article__line3 img-w"  v-animate-onscroll="'animated fadeInLeft'">
             <img src="@/assets/img/article7/line3.png" alt="">
           </div>-->
          <div class="article-wrapper article-wrapper--pb6 article-wrapper--mt article-wrapper--inner article-wrapper--shifted-right">
            <h3 id="element" class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
              {{ '«Такая мера поможет многим простым семьям»' | typograf }}
            </h3>
            <p class="article-text__enlarged" v-animate-onscroll="'animated fadeInUp'">
              {{ 'В мае 2021 года президент Владимир Путин подписал поручение о возврате половины стоимости путевок в детские лагеря. С таким предложением выступила партия «Единая Россия». В ходе обращения к Федеральному собранию президент поручил правительству возмещать гражданам, приобретающим путевки в организации отдыха и оздоровления детей, до 50 процентов их стоимости.' | typograf }}
            </p>
            <div class="article-text__quote article-text__quote--bluearticle-text__quote--nbm" v-animate-onscroll="'animated fadeInUp'">
              <span class="char"
                v-for="(letter, index) in titles[1]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
            </div>
          </div>
        </div>
        <div class="article-wrapper article-wrapper--inner">
          <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote.png" alt="">
            </div>
            {{ '«В партию “Единая Россия” обращаются родители, которые хотят купить путевки в детские лагеря, рассчитывая вернуть часть потраченных средств», — заявляла 14 мая координатор партийного проекта «Крепкая семья», первый заместитель председателя комитета Госдумы по вопросам семьи, женщин и детей Ольга Окунева.' | typograf }}
          </div>
          <div class="mobile-visible article__img article__img3 img-w"  v-animate-onscroll="'animated fadeInRight'">
            <img src="@/assets/img/article7/img3.png" alt="">
          </div>
          <p class="article-text__text clear" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Эта программа, которую проводит Ростуризм, стартовала 25 мая. К ней подключились более тысячи государственных и коммерческих лагерей из разных регионов страны. Родители могли выбрать любой объект из списка партнеров программы на сайте мирпутешествий.рф, приобрести путевку, оплатив ее картой «Мир», а затем в течение пяти дней автоматически получить кешбэк в размере до 50 процентов стоимости, но не более 20 тысяч рублей. Узнав о программе «детского кешбэка», Виктория Волкова позвонила в тот самый детский лагерь, куда пыталась отправить Егора в минувшем году.' | typograf }}
          </p>
          <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote.png" alt="">
            </div>
            {{ '«В лагере мне сказали, что сейчас [на путевке] можно сэкономить в два раза и приобрести ее за 8,5 тысячи рублей вместо 17 тысяч. Я обрадовалась, за день оформила карту “Мир” и с нее оплатила путевку. Через три дня мне вернули половину ее стоимости», — говорит Виктория.' | typograf }}
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Теперь Егор Волков поедет в обычный загородный лагерь со спортивным отрядом, где для ребят будут проводиться регулярные тренировки. В стоимость его путевки входит пятиразовое питание, а также различные развлечения и активности.' | typograf }}
          </p>
        </div>
        <div class="article-text__shifted-box">
          <div class="article__img article__img4 img-w"  v-animate-onscroll="'animated fadeInLeft'">
            <img src="@/assets/img/article7/img4.png" alt="">
          </div>
          <div class="mobile-hidden article__img article__img14 img-w"  v-animate-onscroll="'animated fadeInRight'">
          <img src="@/assets/img/article7/img14.png" alt="">
        </div>
        <div class="article-wrapper article-wrapper--mt article-wrapper--inner article-wrapper--shifted-left">
            <div class="article-text__quote article-text__quote--blue article-text__quote--blue-nm" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[2]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
            </div>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Мать Егора уверена:  провести смену в лагере для ребенка гораздо полезнее, чем просто находиться дома или на даче.' | typograf }}
            </p>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Во-первых, подросток постоянно находится под присмотром, а значит, в безопасности; во-вторых, с ним будут заниматься — проводить тренировки, интеллектуальные игры, готовить вечерние выступления, играть в КВН. А в-третьих, в лагере дети общаются между собой, развиваются и социализируются.' | typograf }}
            </p>
            <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
              <div class="article-text__quote-icon img-w">
                <img src="@/assets/img/quote.png" alt="">
              </div>
              {{ '«Обычно мой ребенок, как и многие другие, проводит много времени за компьютером. А так сын будет играть на природе со сверстниками. Ему будет что вспомнить», — считает Виктория.' | typograf }}
            </div>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Воспользовался программой «детского кешбэка» и Александр Патешман: он купил путевку для дочери почти сразу после того, когда о скидках на детский отдых стали сообщать в новостях. Через несколько дней после покупки путевки на карту ему вернулись 20 тысяч рублей. «Дочь проведет три недели в хорошем лагере на море за 24 тысячи рублей — это очень выгодно. Путевка туда без скидки стоила бы 44 тысячи», — объясняет Александр.' | typograf }}
            </p>
          </div>
        </div>
        <div class="article-wrapper article-wrapper--pb article-wrapper--inner">
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'По его словам, в рамках программы можно было выбрать самые разные варианты по стоимости, по продолжительности смены (от недели до 21 дня) и по расположению. Предлагались детские лагеря в Подмосковье, Санкт-Петербурге и Ленинградской области, в Сибири, на Урале, на юге и в других регионах.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Семья Патешман выбрала Анапу.' | typograf }}
          </p>
          <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[3]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'На смену она поехала вместе с подругой, семья которой тоже присоединилась к программе кешбэка. Школьницы с нетерпением ждали начала смены — первого самостоятельного приключения.' | typograf }}
          </p>
          <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote.png" alt="">
            </div>
            {{ '«Вместо того чтобы сидеть дома в интернете, ребенок сможет отдохнуть в лагере. Поправить здоровье, найти друзей, получить новый опыт и яркие впечатления — это очень здорово», — отмечает Патешман.' | typograf }}
          </div>
        </div>
      </div>
    </section>

    <section class="article-text">
      <div class="mobile-hidden article__img article__img15 img-w">
        <img src="@/assets/img/article7/img15.png" alt="">
      </div>
      <div class="mobile-hidden article__img article__img16 img-w"  v-animate-onscroll="'animated fadeInRight'">
        <img src="@/assets/img/article7/img16.png" alt="">
      </div>
      <div class="article-wrapper article-wrapper--mt">
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Кешбэк помогает отправлять детей на отдых»' | typograf }}
        </h3>
        <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
          {{ 'В начале августа глава Ростуризма Зарина Догузова подвела промежуточные результаты работы программы доступных поездок в детские лагеря. По ее словам, с момента старта программы родители купили более 350 тысяч путевок. В среднем они приобретают около трех тысяч путевок в день. ' | typograf }}
        </p>
        <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[4]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Общая сумма, которую россияне потратили в рамках «детского кешбэка», составила около девяти миллиардов рублей, примерно четыре миллиарда из которых позже вернулась родителям.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'В Ростуризме напомнили, что покупать путевки со скидками можно до 31 августа, а вернуться со смены ребенок может до 15 сентября. В рамках программы нет ограничений по количеству поездок на одну семью — многодетные семьи могут отправить всех детей, и с каждой купленной путевки получить возврат. Для удобства все путевки можно оплатить одной банковской картой, поскольку количество транзакций не ограничено.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Зарина Догузова добавила, что сегодня все, кто купил путевки до старта детского кешбэка 25 мая, тоже могут вернуть средства. Для этого нужно подать заявление на сайте Госуслуг после того, как ребенок вернется из лагеря, вплоть до 20 октября. Все заявления будут рассматриваться и проверяться в регионах.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'По мнению председателя правления Фонда детских лагерей Андрея Данилова, благодаря программе «детского кешбэка» российские семьи получили возможность экономно отправить детей на отдых.' | typograf }}
        </p>
      </div>
      <div class="article-text__shifted-box">
        <div class="article__img article__img5 img-w" v-animate-onscroll="'animated fadeInLeft'">
          <img src="@/assets/img/article7/img5.png" alt="">
        </div>
        <!--<div class="article__line article__line5 img-w"  v-animate-onscroll="'animated fadeInDown'">
          <img src="@/assets/img/article7/line5.png" alt="">
        </div>-->
        <div class="article-wrapper article-wrapper--shifted-right">
          <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote.png" alt="">
            </div>
            {{ '«Кешбэк помогает россиянам отправлять детей на отдых. Сейчас в хороших коммерческих лагерях отдыхает 15-20 процентов школьников, родители которых раньше не могли позволить себе приобрести такую путевку», — говорит Данилов.' | typograf }}
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Кроме того, правительство при помощи программы поддержало и сами детские лагеря, которые пережили кризис в прошлом году.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'По словам эксперта, важно и то, что именно детский лагерь — самое безопасное место для ребенка во время пандемии COVID-19.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Там соблюдаются все меры профилактики заболевания, все сотрудники прививаются или проходят ПЦР-тестирование, а дети — регулярный медицинский осмотр с измерением температуры. Если ребенок все-таки заболеет, ему сразу окажут помощь и изолируют от остальных детей.' | typograf }}
          </p>
          <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote.png" alt="">
            </div>
            {{ '«Мы очень надеемся, что программа “детского кешбэка” продолжится и в следующем году, причем будет действовать не только летом, но и в другие времена года. Тогда родители смогли бы устраивать качественный отдых своим детям 12 месяцев в году», — заключает Андрей Данилов.' | typograf }}
          </div>
        </div>
      </div>
      <div class="article-wrapper">
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          Программа «Детского кешбэка» в России<sup>*</sup>
        </h3>
      </div>
    </section>

    <div class="info">
      <div class="info__columns info__columns--pt2">
        <div class="info__column info__column--df">
          <div class="info__amount info__amount--a7">
            3 тыс.
          </div>
          <div class="info__amount-descr info__amount-descr--a7">
            {{ 'путевок в детские лагеря покупается каждый день' | typograf }}
          </div>
        </div>
        <div class="info__column info__column--df">
          <div class="info__amount info__amount--a7">
            9 млрд.
          </div>
          <div class="info__amount-descr info__amount-descr--a7">
            {{ 'рублей потрачено родителями на путевки' | typograf }}
          </div>
        </div>
      </div>
      <div class="info__columns">
        <div class="info__column info__column--df">
          <div class="info__amount info__amount--a7">
            350 тыс.
          </div>
          <div class="info__amount-descr info__amount-descr--a7">
            путевок куплено <br> с начала программы
          </div>
        </div>
        <div class="info__column info__column--df">
          <div class="info__amount info__amount--a7">
            4 млрд.
          </div>
          <div class="info__amount-descr info__amount-descr--a7">
            {{ 'рублей вернулось на счета родителей' | typograf }}
          </div>
        </div>
      </div>
    </div>
    <div class="info-stars">
      <p class="info-stars__text" v-animate-onscroll="'animated fadeInLeft'">
        {{ 'Промежуточные итоги программы по данным Ростуризма' | typograf }}
      </p>
    </div>
  </div>
</template>

<script>
import './article.styl'
import './info.styl'
import Loading from '@/components/Loading/Loading.vue'
import Layers from '@/components/Layers/Layers.vue'
export default {
  name: 'Article7',
  data () {
    return {
      observer: null,
      isLoading: false,
      titles: [
        'Мама Егора с сожалением поняла, что в детский лагерь ее сын вряд ли сможет попасть',
        'Россияне стали активно интересоваться программой «детского кешбэка».',
        '«Эта поддержка поможет многим простым семьям отправить своего ребенка на отдых» <br> Виктория Волкова',
        'Девочка смогла почти месяц отдыхать на Черном море, купаясь, загорая и общаясь с другими детьми',
        'На счета родителям вернулось 4 000 000 000 рублей',
        '«Для многих полная стоимость путевки слишком высока, особенно если в семье несколько детей» <br> Многодетный отец Александр Патешман'
      ]
    }
  },
  components: {
    Loading, Layers
  },
  methods: {
    disable () {
      const target = document.querySelector('#app')
      target.ontouchstart = (e) => {
        e.preventDefault()
      }
    },
    enable () {
      const target = document.querySelector('#app')
      target.ontouchstart = () => {
        return true
      }
    },
    onDone () {
      (document.getElementById('element-container')).classList.remove('-scale', '-no-blue')
      document.querySelector('html').classList.remove('-lock')
      this.enable()
    },

    onIntersection (entries) {
      entries.forEach((entry) => {
        entry.target.classList.toggle('-visible', entry.isIntersecting)

        if (entry.target.classList.contains('-visible')) {
          (document.getElementById('element-container')).classList.add('-scale')

          document.querySelector('html').classList.add('-lock')
          this.disable()
          this.isLoading = true

          setTimeout(() => {
            const layers = document.querySelectorAll('.bottom-layer')
            for (const layer of layers) {
              layer.classList.toggle('is-active')
            };

            this.$scrollTo('#element', 1800, { cancelable: false, offset: -60, onDone: this.onDone, onCancel: this.onDone })

            this.observer.disconnect()
          }, 1500)
        }
      })
    },

    initObserver () {
      this.observer = new IntersectionObserver(this.onIntersection, {
        root: null,
        threshold: 0.5
      })

      const nodes = document.querySelectorAll('.observer-move')

      nodes.forEach((node) => {
        this.observer.observe(node)
      })
    }
  },
  mounted () {
    const titles = []

    this.titles.forEach((item) => {
      titles.push(item.split(' '))
    })
    this.titles = titles

    this.initObserver()
  }
}
</script>

<style scoped lang="stylus">
#element-container
  transition: all 1s ease-out

  &.-no-blue
    background #f9f9f9

    .article-cir__21, .article__line3
      opacity 0

  #element-content
    transform-origin 50% 0
    transition: all 0.4s ease-out

  &.-scale
    #element-content
      transition: none
      transform scale(0.8)

.article__img1
  position: absolute
  width: 20rem
  left: 0
  top: 22rem

.article__img2
  position: absolute
  width: 50rem
  left: 0
  top: 1rem

.article__img3
  position: absolute
  width: 51rem
  right: 0
  top: 4rem
  z-index: 15

  @media(max-width: 950px)
    float: right

.article__img4
  position: absolute
  width: 53rem
  left: -3.3rem
  top: 6rem
  z-index: 15

.article__img5
  position: absolute
  width: 59rem
  right: 0
  top: 5rem
  z-index: 15

  @media(max-width: 950px)
    float: right

.article__line3
  position: absolute
  width: 38rem
  right: 0
  top: 4rem
  z-index: 4

.article__img6
  position: absolute
  width: 28rem
  right: 0
  top: 0

  @media(max-width: 950px)
    float: right
    width: 15rem
    margin: 0

.article__line4
  position: absolute
  width: 35rem
  left: 0
  top: 4rem
  z-index: 4

.article__img7
  position: absolute
  width: 29rem
  left: 0
  top: 85rem

  @media(max-width: 950px)
    display: none

.article__img8
  position: absolute
  width: 57rem
  left: 0
  top: 10rem
  z-index: 15

  @media(max-width: 950px)
    float: right

.article__line5
  position: absolute
  width: 38rem
  right: 0
  top: 4rem
  z-index: 4

.article__line2
  position: absolute
  width: 47rem
  left: 0
  top: 2.5rem
  z-index: 14

.article__line6
  position: absolute
  right: 3rem
  top: 0
  width: 85rem

.article__img10
  position: absolute
  width: 11rem
  top: 30rem
  right: 5rem
  opacity: 0

.article__img11
  position: absolute
  width: 18rem
  top: 90rem
  right: 0

.article__img12
  position: absolute
  width: 13rem
  left: 4rem
  top: 135rem

.article__img13
  position: absolute
  width: 12rem
  left: 3rem
  top: 18rem

.article__img14
  position: absolute
  width: 12rem
  right: 0
  top: 100rem

.article__img15
  position: absolute
  width: 18rem
  left: 0
  top: 30rem

.article__img16
  position: absolute
  width: 11rem
  right: 4rem
  top: 20rem
</style>
